import { IButtonStyles, ILabelStyles, IStackTokens, IStyle, IProcessedStyleSet, concatStyleSets, mergeStyleSets } from 'office-ui-fabric-react';
import { ShouldShowOneNotePageInfoBar } from '../../../backend/OneNote/OneNoteTranscriptionManager';
import { AppLayoutSettings } from '../../common/styles/common.styles';
import { getSecondaryButtonOverrideStyles } from '../../components/AppButton';

const playerContainerHeightPx = 134;
const buttonContainerHeightPx = 50;

const noAudioFileContainerHeightPx = 40;
const noAudioFileContainerPaddingLeftPx = 16;
const oneNotePageInfoBarHeightPx = 40;

export interface TranscribingStyles {
  playerContainer: IStyle;
  cardsContainer: IStyle;
  buttonContainer: IStyle;
  noAudioFileContainer: IStyle;
}

export const getExplainedLabelStyles = (): ILabelStyles => {
  return AppLayoutSettings.AppCommonStyles.getPageTopLabelStyles();
};

export const getButtonContainerStackTokens = (): IStackTokens => {
  const spacing: IStackTokens = {
    childrenGap: '14px'
  };

  return spacing;
};

export const getAddToDocumentButtonCustomStyles = (): Partial<IButtonStyles> => {
  return {
    root: {
      width: '136px',
      color: AppLayoutSettings.getAppColorContainer().primaryWidgetLabelColor.value
    }
  };
};

export const getAppAddToDocumentMenuButtonCustomStyles = (): Partial<IButtonStyles> => {
  return {
    root: {
      width: '158px',
      selectors: {
        [`:focus`]: {
          outline: '1px solid',
          outlineColor: AppLayoutSettings.getAppColorContainer().keyboardFocusColor.value
        }
      }
    },
  };
};

export const getStartOverButtonCustomStyles = (): Partial<IButtonStyles> => {
  const secondaryButtonStyles = getSecondaryButtonOverrideStyles();
  const customStyles = {
    root: {
      width: '136px'
    }
  };

  return concatStyleSets(secondaryButtonStyles, customStyles);
};

const getTranscribingPageStylesForZoomedOut = (showAudioPlayer: boolean): IProcessedStyleSet<TranscribingStyles> => {
  const styles: TranscribingStyles = {
    playerContainer: {
      top: ShouldShowOneNotePageInfoBar() ? `${oneNotePageInfoBarHeightPx}px` : '0px',
      height: `${playerContainerHeightPx}px`,
      width: '100%'
    },
    cardsContainer: {
      top: showAudioPlayer ? (ShouldShowOneNotePageInfoBar() ? `${playerContainerHeightPx + oneNotePageInfoBarHeightPx}px` : `${playerContainerHeightPx}px`) :
        (ShouldShowOneNotePageInfoBar() ? `${noAudioFileContainerHeightPx + oneNotePageInfoBarHeightPx}px` : `${noAudioFileContainerHeightPx}px`),
      bottom: `${buttonContainerHeightPx}px`,
      width: '100%'
    },
    buttonContainer: {
      bottom: '0px',
      display: 'flex',
      justifyContent: 'space-around',
      height: `${buttonContainerHeightPx}px`,
      width: '100%',
      alignItems: 'center',
      top: '100%'
    },
    noAudioFileContainer: {
      display: 'flex',
      height: `${noAudioFileContainerHeightPx}px`,
      width: '100%',
      paddingLeft: `${noAudioFileContainerPaddingLeftPx}px`
    }
  };

  return mergeStyleSets(styles);
}

const getTranscribingPageStylesForDefaultZoom = (showAudioPlayer: boolean): IProcessedStyleSet<TranscribingStyles> => {
  const styles: TranscribingStyles = {
    playerContainer: {
      position: 'fixed',
      top: ShouldShowOneNotePageInfoBar() ? `${oneNotePageInfoBarHeightPx}px` : '0px',
      height: `${playerContainerHeightPx}px`,
      width: '100%'
    },
    cardsContainer: {
      position: 'fixed',
      top: showAudioPlayer ? (ShouldShowOneNotePageInfoBar() ? `${playerContainerHeightPx + oneNotePageInfoBarHeightPx}px` : `${playerContainerHeightPx}px`) :
        (ShouldShowOneNotePageInfoBar() ? `${noAudioFileContainerHeightPx + oneNotePageInfoBarHeightPx}px` : `${noAudioFileContainerHeightPx}px`),
      bottom: `${buttonContainerHeightPx}px`,
      width: '100%',
      overflowY: 'auto',
      overflowX: 'hidden'
    },
    buttonContainer: {
      position: 'fixed',
      bottom: '0px',
      display: 'flex',
      justifyContent: 'space-around',
      height: `${buttonContainerHeightPx}px`,
      width: '100%',
      alignItems: 'center'
    },
    noAudioFileContainer: {
      position: 'fixed',
      display: 'flex',
      height: `${noAudioFileContainerHeightPx}px`,
      width: '100%',
      paddingLeft: `${noAudioFileContainerPaddingLeftPx}px`
    }
  };

  return mergeStyleSets(styles);
}

export const getTranscribingPageStyles = (showAudioPlayer: boolean, isAudioPlayerZoomedOutOfScreen: boolean): IProcessedStyleSet<TranscribingStyles> => {
  if (isAudioPlayerZoomedOutOfScreen) {
    return getTranscribingPageStylesForZoomedOut(showAudioPlayer);
  }
  else {
    return getTranscribingPageStylesForDefaultZoom(showAudioPlayer);
  }
};